export default "__VITE_ASSET__CUt9uMUm__"